import React from 'react'
import { PaymentResults } from './types'
function DisplayFound ({
  paymentResults,
}: {
    paymentResults: PaymentResults[];
  }) {
  const disabled = paymentResults.filter((payment) => payment.disabled).length
  const totalPayments = paymentResults.length

  if (totalPayments === 0) {
    return (
        <div style={{ marginTop: '10px' }}>
          <div className="alert alert-info">No Recurring Payments Found</div>
        </div>
    )
  }

  return (
      <div style={{ marginTop: '10px' }}>
        <div className="alert alert-info">
          {totalPayments} recurring payment(s) were found.
        </div>
        {disabled > 0 && (
          <div className="alert alert-danger">
            {disabled} disabled recurring payment(s) were found.
          </div>
        )}
      </div>
  )
}

export default DisplayFound
